import axios from 'axios';

const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5001').replace(/\/api$/, '');

export interface ApiSalesOrderSnapshot {
  id: string;
  salesOrderInternalId: string;
  orderNumber: string;
  customer: string;
  location: string;
  date: string;
  workOrderInternalIds: string[];
  otherItems: unknown[];
  firstSeenAt: string;
  lastSeenAt: string;
  completedAt?: string;
}

export interface SalesOrderHistoryQuery {
  completed?: 'true' | 'false' | 'all';
  from?: string;
  to?: string;
  customer?: string;
  orderNumber?: string;
  location?: string;
  limit?: number;
}

export async function listSalesOrderHistory(
  token: string | null,
  query: SalesOrderHistoryQuery = {}
): Promise<ApiSalesOrderSnapshot[]> {
  const { data } = await axios.get(`${API_URL}/api/sales-orders/history`, {
    params: query,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  return data;
}
